// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"rq-z","imageAndVideoCount":"sq-z","imageAndVideoContainer":"tq-z","viewAllReviews":"uq-z"};